import React from 'react'

function HowImarikaChamaa() {
  return (
    <div>

Each member is expected to complete an application form indicating their intended contribution from Kes 1,000 each. As you contribute, your funds earn competitive returns. You’re the group investments, each member also qualifies for a Free Life Insurance cover of Kes 50,000.<br/>
<br></br>
Each month, a statement is sent to the individual member as well as a Consolidated chamaa statement sent to the Treasurer or appointed chamaa member.<br/>
<br></br>
Members can increase or reduce your contributions at any time giving you the opportunity to control how you get to your final goal.<br/>




    </div>
  )
}

export default HowImarikaChamaa